import * as React from 'react';
import Typography from '@mui/material/Typography';



export default function SimpleAccordion() {

  



    return (
        <div
        style={{
          height: 'auto',
          display: "flex",
          width: '100%',
          backgroundColor: 'rgba(238, 238, 238, 0.9)',
          marginTop: 10,
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          padding: 10,
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
       
        <Typography>
          Esta sección se encuentra en construcción.
        </Typography>

      </div>

    );
}
